if (typeof ARCHIPEL === "undefined") {
  var ARCHIPEL = {};
}

import { gsap } from "./vendor/gsap.min";
import { SplitText } from "./vendor/SplitText.min";
import { ScrollTrigger } from "./vendor/ScrollTrigger.min";
import { ScrollSmoother } from "./vendor/ScrollSmoother.min";
import { Draggable } from "./vendor/Draggable.min";
import { ScrollToPlugin } from "./vendor/ScrollToPlugin.min";

import { menu } from "./actions/menu";
import { general } from "./actions/general";
import { scroll } from "./actions/scroll";
import { accordion } from "./actions/accordion";
import { forms } from "./actions/forms";

import { home } from "./pages/home";
import { traitements } from "./pages/traitements";
import { archiveTraitement } from "./pages/archive-traitement";
import { specialistes } from "./pages/specialistes";
import { singleClinique } from "./pages/single-clinique";
import { about } from "./pages/about";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import Cookies from "js-cookie";

import "../scss/styles.scss";
$ = jQuery;

if(WPURLS.post_type == 'traitement') {
  if (!Cookies.get("vicpark-coordinates")) {
    $.getJSON(
      "https://api.geoapify.com/v1/ipinfo?&apiKey=c0395b5f5f7e4a9a8d39870d510d85de",
      function (response) {
        //console.log(response);
        const coordinates = response.location.latitude + "," + response.location.longitude;
        // Get user location and save in a cookie
        Cookies.set("vicpark-coordinates", coordinates, { expires: 1 / 24 });
        listClosestClinics(coordinates);
      }
    )
  } else {
    const coordinates = Cookies.get('vicpark-coordinates');
    listClosestClinics(coordinates);
  };
}

// TOP BANNER
if (!Cookies.get("vicpark-top-banner") && $('.top-banner').length) {
  setTimeout(function(){
    const adminBarH = $('body').hasClass('admin-bar') ? 32 : 0;
    const topBannerH = $('.top-banner').outerHeight();
    $('body').addClass('has-top-banner');
    $('.rt-container').css({paddingTop:`${(topBannerH + adminBarH)}px`})
    $('header.top').css({top:`${(topBannerH + adminBarH)}px`})
  }, 1500)

  $('.close-top-banner').on('click', function(e){
    e.preventDefault();
    Cookies.set("vicpark-top-banner", 'visible', { expires: 1 / 48 });
    $('body').removeClass('has-top-banner')
    $('.rt-container').css({paddingTop:0})
    $('header.top').css({top:0})
  })
}

// POPUP BANNER
if (!sessionStorage.getItem('vicpark-popup-banner') && $('.popup-banner').length) {
  sessionStorage.setItem('vicpark-popup-banner',1)
  setTimeout(function(){
    $('body').addClass('has-popup-banner');
  }, 1500)

  $('.close-popup-banner').on('click', function(e){
    e.preventDefault();
    $('body').removeClass('has-popup-banner')
  })
}


function listClosestClinics(coordinates) {
  // console.log('%c CALLING AJAX:', 'color:green');
  // console.log(coordinates);
  const rand_num = Math.floor((Math.random() * 1000000) + 1);
  $.ajax({
    type: "POST",
    dataType: "json",
    url: WPURLS.ajaxurl + '?v=' + rand_num,
    data: {
      action: "location_coordinates",
      post_id: WPURLS.post_id,
      coordinates: coordinates,
    },
    success: function (response) {
      // console.log('---------------------------------------------------');
      // console.log(response);
      // console.log('---------------------------------------------------');
      $("#region-container").html(response.response);
    },
    error: function (request, status, error) {
      alert("error: " + error);
    },
  });
}

!function ($) {
  "use strict";

  jQuery(document).ready(function ($) {
    gsap.config({
      nullTargetWarn: false,
    });
    gsap.registerPlugin(
      ScrollTrigger,
      ScrollSmoother,
      SplitText,
      Draggable,
      ScrollToPlugin
    );

    Fancybox.bind("[data-fancybox]", {
      hideScrollbar: false,
    });

    $(".modal-open-book").click(function (e) {
      e.preventDefault();
      Fancybox.show(
        [
          {
            src: "#modal-booking",
          },
        ],
        {
          hideScrollbar: false,
          backdropClick: false,
          on: {
            reveal: (fancybox, slide) => {
              if (typeof scroll.smoother.paused === "function") {
                scroll.smoother.paused(true);
              }
            },
            close: () => {
              if (typeof scroll.smoother.paused === "function") {
                scroll.smoother.paused(false);
              }
            },
          },
        }
      );
    });
    $(".modal-open-clinic").click(function (e) {
      e.preventDefault();
      Fancybox.show([{ src: "#modal-clinic", type: "inline" }], {
        hideScrollbar: false,
        dragToClose: false,
        on: {
          reveal: (fancybox, slide) => {
            if (typeof scroll.smoother.paused === "function") {
              scroll.smoother.paused(true);
            }
          },
          close: () => {
            if (typeof scroll.smoother.paused === "function") {
              scroll.smoother.paused(false);
            }
          },
        },
      });
    });
    $(".modal-open-contact").click(function (e) {
      e.preventDefault();
      Fancybox.show([{ src: "#modal-contact" }], {
        hideScrollbar: false,
        on: {
          reveal: (fancybox, slide) => {
            if (typeof scroll.smoother.paused === "function") {
              scroll.smoother.paused(true);
            }
          },
          close: () => {
            if (typeof scroll.smoother.paused === "function") {
              scroll.smoother.paused(false);
            }
          },
        },
      });
    });
    $(".modal-open-expert-book").click(function (e) {
      e.preventDefault();
      Fancybox.show([{ src: "#modal-expert-booking" }], {
        hideScrollbar: false,
        on: {
          reveal: (fancybox, slide) => {
            if (typeof scroll.smoother.paused === "function") {
              scroll.smoother.paused(true);
            }
          },
          close: () => {
            if (typeof scroll.smoother.paused === "function") {
              scroll.smoother.paused(false);
            }
          },
        },
      });
    });

    $(".home-hero img").attr("data-speed", "0.5");

    scroll.init();

    menu.init();
    forms.init();
    accordion.init();
    home.init();
    traitements.init();
    archiveTraitement.init();
    specialistes.init();
    singleClinique.init();
    about.init();
    general.init();
    ScrollTrigger.refresh();

    // var requestOptions = {
    //   method: 'GET',
    // };

    // if (!Cookies.get("vicpark-coordinates")) {
    //   fetch("https://api.geoapify.com/v1/ipinfo?&apiKey=c0395b5f5f7e4a9a8d39870d510d85de", requestOptions)
    //   .then(response => response.json())
    //   .then(result => {
    //     console.log(result);
    //     Cookies.set("vicpark-coordinates", JSON.stringify([result.location.latitude, result.location.longitude]), { expires: 1 });
    //   })
    //   .catch(error => console.log('error', error));

    // }
  });
}.call(ARCHIPEL, jQuery);
